'use strict';
var defineBuiltIn = require('../internals/define-built-in');

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/define-built-ins.js
// module id = 128
// module chunks = 0